/*
 * OASIS NATION — gold-wipe page transition
 * Incoming reveal is pure CSS (runs even if JS fails, so the overlay can
 * never get stuck covering the page). This only handles the outgoing cover.
 */
(function () {
  'use strict';
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var wipe = document.querySelector('[data-wipe]');
  if (!wipe) return;

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest('a');
    if (!a) return;
    var href = a.getAttribute('href');
    if (!href || href.charAt(0) === '#') return;
    if (a.target === '_blank' || a.hasAttribute('download')) return;
    if (/^(mailto:|tel:|javascript:)/i.test(href)) return;
    if (a.id === 'cart-icon-bubble' || a.closest('#cart-icon-bubble')) return;
    var url;
    try { url = new URL(a.href, window.location.href); } catch (_) { return; }
    if (url.origin !== window.location.origin) return;
    if (url.pathname === '/cart') return; // let the cart drawer handle this
    if (url.pathname === window.location.pathname && url.search === window.location.search) return;
    if (a.closest('form, product-form, cart-drawer')) return;

    e.preventDefault();
    wipe.classList.add('is-leaving');
    var go = function () { window.location.href = a.href; };
    wipe.addEventListener('transitionend', go, { once: true });
    setTimeout(go, 650); // fallback if transitionend doesn't fire
  });
})();
